<template>
    <!-- 预约登记表 -->
    <div>
      <el-row>
        <!-- 工具条 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
          @submit.native.prevent>
          <el-form-item label="老人姓名">
            <el-input v-model.trim="formInline.oldName"  :clearable="true" placeholder="请选择老人" style="width: 100%"
              ></el-input>
          </el-form-item>
          <el-form-item label="预约时间">
            <el-date-picker :clearable="true" v-model="formInline.visitTime" type="date" placeholder="请选择预约时间"
              value-format="yyyy-mm-dd" format="yyyy-mm-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search" plain>查询</el-button>
            <el-button type="warning" icon="el-icon-plus" @click="addContract" plain>添加</el-button>
            <el-button
                type="info"
                @click="exportExcel"
                icon="el-icon-download"
                plain>记录导出</el-button>
          </el-form-item>
        </el-form>
        <el-table style="width: 100%" :data="tableData" v-loading="tableLoading" :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
          <el-table-column prop="oldName" label="老人姓名" min-width="80">
          </el-table-column>
          <el-table-column prop="oldSex" label="性别" min-width="60">
            <template slot-scope="scope">
              <p>{{scope.row.oldSex == 0 ?"男":"女"}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="家庭地址" min-width="150"></el-table-column>
          <el-table-column prop="family" label="家属" min-width="100"></el-table-column>
          <el-table-column prop="familyPhone" label="联系电话" min-width="100"></el-table-column>
          <el-table-column prop="visitTime" label="登记时间" min-width="100"></el-table-column>
          <el-table-column prop="receptionist" label="接待员" min-width="100"></el-table-column>
          <el-table-column label="操作" min-width="110">
            <template slot-scope="scope">
              <a @click="handleDelete(scope.$index, scope.row)" style="cursor: pointer;">
                <img class="handedness" src="@/assets/beadhouse/shanhcu.png" />
              </a>
              <a @click="handleEdit(scope.$index, scope.row)" style="cursor: pointer;">
                <img class="handedness" src="@/assets/beadhouse/xiugai_icon_1.png" />
              </a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize" align="center" class="fenye">
        </el-pagination>
      </el-row>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  import { baseURL } from "@/utils/request.js";
  export default {
    name: "ContractManage",
    data() {
      return {
        formInline: {
          oldName: "",
          visitTime: "",
        },
        tableData: [], //表格数据
        tableLoading: false, //表格加载的loading
        /* 分页的 */
        currentPage: 1, //初始页
        pageNo: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber: 0, //数据的总数,
        fieldsVisisble: false,
        oldNameOptions: [], // 老人姓名集合
        dialogVisible:false,
        addForm:{},
      };
    },
    methods: {
      //修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      /*
        添加老人
      */
      addContract() {
        bus.$emit("homePage", {
          type: "jump",
          path: "/OldReservationAdd",
          title: "新增预约登记",
        });
      },
      handleDelete(index,row){
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          ancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        }).then(() => {
          console.log(row.id);
          let param = {
            id:row.id
          };
          this.$postJson("omc/oldReservation/delete",
            param
          ).then(res => {
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.search();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          })
        })
      },
      handleEdit(index, row) {
        bus.$emit("homePage", {
          type: "jump",
          path: "/OldReservationAdd",
          title: "修改预约登记",
          params: row
        });
      },
      //导出
      exportExcel() {
        window.location.href =
        baseURL +
        `omc/api/downOldReservationTableExcel?groupId=${window.sessionStorage.getItem("groupId")}`;
      },
      /*
        点击查询
      */
      search() {
        this.queryContract(
          this.formInline.oldmanId,
          this.formInline.year,
          (this.pageNo = 1),
          (this.pageSize = 10)
        );
      },
      /*
        查询分页列表
      */
      queryContract() {
        let params = {};
        if (this.formInline.oldName != "" || null || undefined) {
          params.oldName = this.formInline.oldName;
        }
        if (this.formInline.visitTime != "" || null || undefined) {
          params.visitTime = this.formInline.visitTime;
        }
        params.pageNo = String(this.pageNo);
        params.pageSize = String(this.pageSize);
        this.tableData = [];
        this.tableLoading = true;
        this.$postJson("omc/oldReservation/selectShowAll", params).then((res) => {
          if (res.code == 200) {
            if (res.result.list != null) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;
              this.tableData = res.result.list;
            } else {
              this.tableData = [];
              this.pageSize = 10;
              this.currentPage = 1;
              this.totalDataNumber = 0;
            }
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
          setTimeout(() => {
            this.tableLoading = false;
          }, 500);
        });
      },
      /*
        当前页变化
      */
      handleCurrentChange(val) {
        this.pageNo = val;
        this.queryContract(); //刷新套餐列表的数据
      },
    },
    mounted() {
      this.queryContract();
    },
    computed: {},
  };
  </script>
  <style lang="scss" scoped>
  .fenye {
    padding: 30px 0;
    background: #fff;
  }
  </style>
    